export const REQUEST_IMAGES_PATH = '/static/images/request';
